import { Logger } from '~/plugins/log'
import { DEFAULT_PAGE_THEME, PAGE_THEMES } from '~/constants/pageThemes'
import { isValidPageTheme } from '~/helpers/themes'

const logger = new Logger()
logger.setContext('Page')

const getDefaultState = () => ({
  mobileMenuOpen: false,
  currencyMenuOpen: false,
  outstandingRequests: {},
  defaultTimeout: 5000,
  cookieStatus: null,
  showCookieModal: false,
  pageTheme: DEFAULT_PAGE_THEME,
  hideHiringBanner: false,
  contentPreviewEnabled: false,
  preventBodyScroll: false
})

export const state = getDefaultState

export const mutations = {
  TOGGLE_MOBILE_MENU (state) {
    state.mobileMenuOpen = !state.mobileMenuOpen
  },
  CLOSE_MOBILE_MENU (state) {
    state.mobileMenuOpen = false
  },
  TOGGLE_CURRENCY_MENU (state) {
    state.currencyMenuOpen = !state.currencyMenuOpen
  },
  CLOSE_CURRENCY_MENU (state) {
    state.currencyMenuOpen = false
  },
  CLOSE_MENUS (state) {
    state.currencyMenuOpen = false
    state.mobileMenuOpen = false
  },
  REQUEST_START (state, [uid, timeout]) {
    state.outstandingRequests = {
      ...state.outstandingRequests,
      [uid]: { start: (new Date()).valueOf(), timeout: timeout || state.defaultTimeout }
    }
  },
  REQUEST_FINISH (state, uid) {
    state.outstandingRequests = Object.fromEntries(Object.entries(state.outstandingRequests).filter(
      ([compareUid]) => parseInt(compareUid) !== parseInt(uid)
    ))
  },
  TIMEOUT_REQUESTS (state) {
    state.outstandingRequests = Object.fromEntries(Object.entries(state.outstandingRequests).filter(
      ([compareUid, { start, timeout }]) => {
        if (start + timeout < (new Date()).valueOf()) {
          logger.debug('Request timed out')
          return false
        }
        return true
      }
    ))
  },
  RESET (state) {
    Object.assign(state, getDefaultState())
  },
  SET_COOKIE_STATUS (state, cookieStatus) {
    state.cookieStatus = cookieStatus
  },
  SET_COOKIE_MODAL_STATE (state, show) {
    state.showCookieModal = show
  },
  SET_THEME (state, theme) {
    state.pageTheme = theme
  },
  HIDE_HIRING_BANNER (state, hidden = true) {
    state.hideHiringBanner = hidden
  },
  SET_CONTENT_PREVIEW_STATE (state, previewEnabled) {
    state.contentPreviewEnabled = previewEnabled
  },
  BLOCK_BODY_SCROLL (state) {
    state.preventBodyScroll = true
  },
  ALLOW_BODY_SCROLL (state) {
    state.preventBodyScroll = false
  }
}

export const getters = {
  isMobileMenuOpen: state => state.mobileMenuOpen,
  isCurrencyMenuOpen: state => state.currencyMenuOpen,
  outstandingRequests: state => state.outstandingRequests,
  anyOutstandingRequests: state => Object.keys(state.outstandingRequests).length > 0,
  cookiesChecked: state => state.cookieStatus !== null,
  cookiesAllowed: state => state.cookieStatus,
  showCookieModal: state => state.showCookieModal,
  pageTheme: state => state.pageTheme,
  hideHiringBanner: state => state.hideHiringBanner,
  contentPreviewEnabled: state => state.contentPreviewEnabled,
  preventBodyScroll: state => state.preventBodyScroll
}

export const actions = {
  SET_PAGE_THEME ({ commit }, theme) {
    const themeToSet = isValidPageTheme(theme) ? PAGE_THEMES[theme] : DEFAULT_PAGE_THEME
    commit('SET_THEME', themeToSet)
  }
}